/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetBulkAppointmentBookingsItem } from './GetBulkAppointmentBookingsItem';
import {
    GetBulkAppointmentBookingsItemFromJSON,
    GetBulkAppointmentBookingsItemFromJSONTyped,
    GetBulkAppointmentBookingsItemToJSON,
    GetBulkAppointmentBookingsItemToJSONTyped,
} from './GetBulkAppointmentBookingsItem';

/**
 * 
 * @export
 * @interface GetBulkAppointmentBookingsResponse
 */
export interface GetBulkAppointmentBookingsResponse {
    /**
     * 
     * @type {Array<GetBulkAppointmentBookingsItem>}
     * @memberof GetBulkAppointmentBookingsResponse
     */
    items: Array<GetBulkAppointmentBookingsItem>;
}

/**
 * Check if a given object implements the GetBulkAppointmentBookingsResponse interface.
 */
export function instanceOfGetBulkAppointmentBookingsResponse(value: object): value is GetBulkAppointmentBookingsResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetBulkAppointmentBookingsResponseFromJSON(json: any): GetBulkAppointmentBookingsResponse {
    return GetBulkAppointmentBookingsResponseFromJSONTyped(json, false);
}

export function GetBulkAppointmentBookingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBulkAppointmentBookingsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GetBulkAppointmentBookingsItemFromJSON)),
    };
}

export function GetBulkAppointmentBookingsResponseToJSON(json: any): GetBulkAppointmentBookingsResponse {
    return GetBulkAppointmentBookingsResponseToJSONTyped(json, false);
}

export function GetBulkAppointmentBookingsResponseToJSONTyped(value?: GetBulkAppointmentBookingsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(GetBulkAppointmentBookingsItemToJSON)),
    };
}

